
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[roomId]",
      function () {
        return require("private-next-pages/[roomId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[roomId]"])
      });
    }
  